<template>
  <transition name="cookie-fade">
    <aside v-if="showBanner" class="cookie-banner" role="dialog" aria-label="Cookie notice">
      <p>Χρησιμοποιούμε απαραίτητα cookies για σωστή λειτουργία και προαιρετικά για βελτίωση εμπειρίας.</p>
      <button type="button" @click="acceptCookies">Αποδοχή</button>
    </aside>
  </transition>
</template>

<script>
export default {
  name: "CookieBanner",
  data() {
    return { showBanner: !this.$cookies.isKey("cookie_accepted") };
  },
  watch: {
    showBanner(value) { this.syncBodyOffset(value); },
  },
  mounted() { this.syncBodyOffset(this.showBanner); },
  beforeUnmount() { this.syncBodyOffset(false); },
  methods: {
    syncBodyOffset(value) {
      document.body.classList.toggle("has-cookie-banner", value);
    },
    acceptCookies() {
      this.$cookies.set("cookie_accepted", "true", "365d");
      this.showBanner = false;
    },
  },
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  left: 50%;
  bottom: 14px;
  z-index: 1200;
  display: flex;
  align-items: center;
  gap: 14px;
  width: min(620px, calc(100vw - 28px));
  padding: 12px 12px 12px 16px;
  border: 1px solid rgba(7, 26, 44, 0.12);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(7, 26, 44, 0.12);
  color: #071B2D;
  font-family: "Manrope", "Inter", system-ui, sans-serif;
  transform: translateX(-50%);
}
.cookie-banner p { flex: 1; margin: 0; font-size: 14px; line-height: 1.45; }
.cookie-banner button { min-height: 40px; padding: 0 14px; border: 0; border-radius: 10px; color: #071B2D; background: #82F2B5; font-weight: 800; white-space: nowrap; }
.cookie-fade-enter-active, .cookie-fade-leave-active { transition: opacity 180ms ease, transform 180ms ease; }
.cookie-fade-enter-from, .cookie-fade-leave-to { opacity: 0; transform: translate(-50%, 8px); }
@media (max-width: 520px) { .cookie-banner { align-items: stretch; flex-direction: column; gap: 10px; bottom: 10px; } .cookie-banner button { width: 100%; } }
</style>
<style>
body.has-cookie-banner { padding-bottom: 82px; }
@media (max-width: 520px) { body.has-cookie-banner { padding-bottom: 148px; } }
</style>
